import React from 'react';
import { useTheme } from 'styled-components';

interface Props {
  size?: number;
  style?: React.CSSProperties;
}

/**
 * CRPD-7274 — the filled warning triangle in the tier panel's "Controls missing maturity" tile
 * (frame node 18064:16179). Distinct from `WarningSvg`, which is the outlined statusRed triangle
 * the Alert banner and the overdue-review column use; this one is solid and gradient-filled.
 */
export const WarningSolidSvg: React.FC<Props> = ({ size = 14, style }) => {
  const colors = useTheme().colors;
  // useId's own value contains colons, which are not valid inside a `url(#…)` reference.
  const id = `grad${React.useId().replace(/:/g, '')}`;

  return (
    <svg
      width={size}
      height={(size * 12) / 13.7168}
      viewBox="0 0 13.7168 12"
      fill="none"
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5629 10.36L7.77718 0.528564C7.58003 0.197144 7.23717 0 6.85717 0C6.48002 0 6.13432 0.197144 5.94004 0.528564L0.154323 10.36C-0.0485402 10.7028 -0.0514001 11.1143 0.145743 11.46C0.340027 11.7971 0.685748 12 1.07146 12H12.6457C13.0314 12 13.3772 11.7971 13.5686 11.46C13.7686 11.1143 13.7657 10.7028 13.5629 10.36ZM6.26881 4.24437H7.23477V5.15494L7.02774 7.70321H6.47584L6.26881 5.15494V4.24437ZM7.11744 9.19959C7.0163 9.3031 6.89548 9.355 6.75527 9.355C6.61493 9.355 6.49411 9.3031 6.39297 9.19959C6.29169 9.09607 6.24118 8.97274 6.24118 8.82905C6.24118 8.68563 6.29169 8.56203 6.39297 8.45851C6.49411 8.355 6.61493 8.3031 6.75527 8.3031C6.89548 8.3031 7.0163 8.355 7.11744 8.45851C7.21858 8.56203 7.26923 8.68563 7.26923 8.82905C7.26923 8.97274 7.21858 9.09607 7.11744 9.19959Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient id={id} x1="6.85841" y1="0" x2="6.85841" y2="12" gradientUnits="userSpaceOnUse">
          <stop stopColor={colors.gp1} />
          <stop offset="1" stopColor={colors.gp2} />
        </linearGradient>
      </defs>
    </svg>
  );
};
